<template>
  <PrintPage :pageNumber="pageNumber" :pageCount="pageCount">
    <template v-slot:header>
      <slot>
        <div class="header-grid"></div>
      </slot>
    </template>

    <div class="content-box">
      <div class="content-box-header">
        <h3>{{ $t('installationTeamDocumentation') }} - 3. {{ $t('solarPanels') }}</h3>
      </div>
      <div class="two-column-grid" v-for="i in range(1, 2)" :key="i">
        <div>{{ $t('solarPanelAttachments_E2') }} {{ $t('image') }} {{ i }}</div>
        <div>
          <img
            v-if="project.enpalReport.solarPanelAttachments_E2[i - 1]"
            :src="project.enpalReport.solarPanelAttachments_E2[i - 1].path"
            alt=""
          />
        </div>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('solarPanelE1State') }}</div>
        <div>
          {{ $t(project.enpalReport.solarPanelE1State) }}
        </div>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('solarPanelAttachment_F') }}</div>
        <div>
          <img
            v-if="project.enpalReport.solarPanelAttachment_F"
            :src="project.enpalReport.solarPanelAttachment_F.path"
            alt=""
          />
        </div>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('solarPanelAttachment_G') }}</div>
        <div>
          <img
            v-if="project.enpalReport.solarPanelAttachment_G"
            :src="project.enpalReport.solarPanelAttachment_G.path"
            alt=""
          />
        </div>
      </div>
    </div>
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';

export default {
  components: {
    PrintPage,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: 1 },
    pageNumber: { type: Number, default: 0 },
  },
  methods: {
    range(min, max) {
      const array = [];
      let j = 0;
      for (var i = min; i <= max; i++) {
        array[j] = i;
        j++;
      }
      return array;
    },
  },
};
</script>

<style src="./ReportPrintPage.scss" lang="scss" />
